import { withWebResponsiveDesign } from 'src/hoc/withWebResponsiveDesign';
import { SaveButtonDesktop } from './save-button-desktop/SaveButtonDesktop';
import { SaveButtonMobile } from './save-button-mobile/SaveButtonMobile';
import { SaveButtonProps } from './SaveButton.types';
import { Attributes } from 'react';

export const SaveButton = withWebResponsiveDesign<SaveButtonProps & Attributes>(
  SaveButtonMobile,
  SaveButtonMobile,
  SaveButtonDesktop,
);
